// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2882":"c6342110","4690":"c6342110","6193":"29b921e3","7853":"6a1dbb1f"}[chunkId] + ".chunk.css";
};